import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SelectModule } from 'primeng/select';
import { Subscription } from 'rxjs';
import IMetadataType from '../../../_interfaces/IMetadataType';
import { MetadataTypesService } from '../../../_services/metadatas/metadata-types.service';
import { CreateMetadataTextComponent } from '../create-metadata/create-metadata-text/create-metadata-text.component';
import { CreateMetadataBooleanComponent } from '../create-metadata/create-metadata-boolean/create-metadata-boolean.component';
import { CreateMetadataOptionComponent } from '../create-metadata/create-metadata-option/create-metadata-option.component';

@Component({
  standalone: true,
  selector: 'app-form-metadata-patients',
  templateUrl: './form-metadata-patients.component.html',
  styleUrls: ['./form-metadata-patients.component.scss'],
  imports: [
    SelectModule,
    CommonModule,
    FormsModule,
    TranslatePipe,

    CreateMetadataTextComponent,
    CreateMetadataBooleanComponent,
    CreateMetadataOptionComponent,
  ],
})
export class FormMetadataPatientsComponent implements OnInit, OnDestroy {
  public metadataTypes: IMetadataType[];
  public metadataType: IMetadataType;
  public subscriptorTranslate: Subscription;

  constructor(
    private metadataTypesService: MetadataTypesService,
    private translate: TranslateService
  ) {}

  loadTypes() {
    this.metadataTypesService.getAll().subscribe((types: IMetadataType[]) => {
      this.metadataTypes = types.map((x) => {
        x.name = this.translate.instant('COMMON.METADATA.' + x.name);
        return x;
      });
    });
  }

  ngOnDestroy(): void {
    this.subscriptorTranslate.unsubscribe();
  }

  ngOnInit(): void {
    this.loadTypes();
    this.subscriptorTranslate = this.translate.onLangChange.subscribe(() => {
      this.loadTypes();
    });
  }
}
